import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const CheckedLabel = styled.label`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 10px;
  border: 0.75px solid var(--bg-back-button);
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
  min-height: 15px;
  transition: border 500ms linear;

  &:hover,
  &:focus {
    border: 0.75px solid var(--bg-button);
  }

  &:hover input ~ span {
    background-color: var(--bg-color);
  }

  & input:checked ~ span {
    background-color: var(--bg-button);
  }

  & input:checked ~ span::after {
    display: block;
  }
`;

export const CheckedInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const Checkmark = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  height: 15px;
  width: 15px;
  background-color: var(--bg-color);
  border: 1px solid var(--bg-button);
  border-radius: 2px;
  margin-right: 10px;
  transition: background-color 500ms linear;

  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 4px;
    top: 2px;
    width: 5px;
    height: 8px;
    border: solid var(--bg-color);
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(35deg);
    -ms-transform: rotate(35deg);
    transform: rotate(35deg);
  }
`;

export const CheckedText = styled.p`
  width: 100%;
  display: inline-block;
  margin-left: 30px;
  margin-top: -2px;

  font-weight: 400;
  font-size: 13px; //11
  line-height: 1.45;
  color: var(--text-color);

  @media ${device.desktop} {
    margin-left: 22px;
    font-size: 13px; //10
    line-height: 1.23; //1.6
  }
`;

export const EmojiBox = styled.div`
  display: block;
  min-width: 20px;
  min-height: 20px;
  width: 20px;
  height: 20px;
  margin-left: 10px;
`;
